// extracted by mini-css-extract-plugin
export default {"root":"style_root__t81jH","contentDivider":"style_contentDivider__+QXa8","addWaterBtn":"style_addWaterBtn__3S66U","btnSave":"style_btnSave__kondX"};